import {Module} from "../index";
import {
  CardIncident,
  GoalIncident,
  Incident,
  Match,
  MissedGoalIncident,
  NeutralIncident,
  SubstitutionIncident
} from "./entity";
import {MatchdayEvaluationEventSubscriber} from "@/modules/match/subscribers/MatchdayEvaluationEventSubscriber";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import BeforeMatchMode from "@/modules/match/services/BeforeMatchMode";
import UserMatchHandler from "@/modules/match/services/UserMatchHandler";
import {UserMatchEvaluationEventSubscriber} from "@/modules/match/subscribers/UserMatchEvaluationEventSubscriber";
import LiveMatchEvaluator from "@/modules/match/services/LiveMatchEvaluator";
import {TYPES} from "@/modules/match/types";
import {LiveMatchHandlerInterface} from "@/modules/match/interfaces";
import CardLiveMatchHandler from "@/modules/match/services/live-match-handlers/CardLiveMatchHandler";
import NeutralLiveMatchHandler from "@/modules/match/services/live-match-handlers/NeutralLiveMatchHandler";
import LaneBasedGoalsHandler from "@/modules/match/services/live-match-handlers/LaneBasedGoalsHandler";
import LaneCalculator from "@/modules/match/services/live-match-handlers/lane-based-goals-handler/LaneCalculator";
import PenaltyMatchHandler from "@/modules/match/services/live-match-handlers/PenaltyMatchHandler";
import EnergyMatchHandler from "@/modules/match/services/live-match-handlers/EnergyMatchHandler";

export class MatchModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [
    Match,
    Incident,
    GoalIncident,
    CardIncident,
    SubstitutionIncident,
    NeutralIncident,
    MissedGoalIncident,
  ];

  eventSubscribers = [
    MatchdayEvaluationEventSubscriber,
    UserMatchEvaluationEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<BeforeMatchMode>(BeforeMatchMode).to(BeforeMatchMode);
    this.app.bind<UserMatchHandler>(UserMatchHandler).to(UserMatchHandler);
    this.app.bind<LiveMatchEvaluator>(LiveMatchEvaluator).to(LiveMatchEvaluator).inTransientScope();
    this.app.bind<LaneCalculator>(LaneCalculator).to(LaneCalculator);

    this.app.bind<LiveMatchHandlerInterface>(TYPES.LiveMatchHandlers).to(CardLiveMatchHandler);
    this.app.bind<LiveMatchHandlerInterface>(TYPES.LiveMatchHandlers).to(NeutralLiveMatchHandler);
    this.app.bind<LiveMatchHandlerInterface>(TYPES.LiveMatchHandlers).to(LaneBasedGoalsHandler);
    this.app.bind<LiveMatchHandlerInterface>(TYPES.LiveMatchHandlers).to(PenaltyMatchHandler);
    this.app.bind<LiveMatchHandlerInterface>(TYPES.LiveMatchHandlers).to(EnergyMatchHandler);
  }

  boot() {
    super.boot();
  }
}
